import * as React from "react";
import MaskedInput from "react-text-mask";
import TextField from "@material-ui/core/TextField";
import moment from "moment";

// MM/DD/YYYY
const mask = [/\d/, /\d/, "/", /\d/, /\d/, "/", /\d/, /\d/, /\d/, /\d/];

export const DateInput = (props) => {
  // remove inputref from props passed down to the <input> component
  // this caused type errors
  // https://github.com/text-mask/text-mask/issues/714
  const { inputRef, ...others } = props;
  return <MaskedInput mask={mask} guide={true} {...others} />;
};

const DateField = (props) => (
  <TextField
    placeholder="MM/DD/YYYY"
    InputProps={{ inputComponent: DateInput }}
    {...props}
  />
);

export const isValid = (val) => moment(val, "MM/DD/YYYY", true).isValid();

export default DateField;



// WEBPACK FOOTER //
// ./src/components/DateField.jsx